// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconOutlineNumberedList = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.8506 20.25H9.85059C9.44059 20.25 9.10059 19.91 9.10059 19.5C9.10059 19.09 9.44059 18.75 9.85059 18.75H19.8506C20.2606 18.75 20.6006 19.09 20.6006 19.5C20.6006 19.91 20.2606 20.25 19.8506 20.25Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.8506 13.25H9.85059C9.44059 13.25 9.10059 12.91 9.10059 12.5C9.10059 12.09 9.44059 11.75 9.85059 11.75H19.8506C20.2606 11.75 20.6006 12.09 20.6006 12.5C20.6006 12.91 20.2606 13.25 19.8506 13.25Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.8506 6.25H9.85059C9.44059 6.25 9.10059 5.91 9.10059 5.5C9.10059 5.09 9.44059 4.75 9.85059 4.75H19.8506C20.2606 4.75 20.6006 5.09 20.6006 5.5C20.6006 5.91 20.2606 6.25 19.8506 6.25Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.4502 7.42509H5.5502V7.32509V3.67529V3.57529H5.4502H5.06674H5.04113L5.01867 3.5876L3.77127 4.27136L3.71934 4.29983V4.35905V4.97351V5.14226L3.86735 5.06123L4.79118 4.55552V7.32509V7.42509H4.89118H5.4502Z',
      fill: 'currentColor',
      stroke: 'currentColor',
      strokeWidth: '0.2',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.07456 14.4248H6.17456V14.3248V13.7859V13.6859H6.07456H4.29496C4.33742 13.5815 4.42461 13.4915 4.55159 13.4036C4.67835 13.3158 4.83079 13.2391 4.99664 13.1557C5.05621 13.1257 5.11751 13.0948 5.17997 13.0623C5.638 12.8236 6.13833 12.502 6.13833 11.8115C6.13833 11.4313 6.0149 11.1179 5.77354 10.9005C5.53363 10.6845 5.18988 10.5748 4.77034 10.5748C4.30808 10.5748 3.93607 10.7083 3.69036 10.9704C3.44428 11.2328 3.33986 11.6082 3.3801 12.0603L3.38822 12.1515H3.47971H4.05031H4.16672L4.14916 12.0364C4.11113 11.7871 4.15695 11.6065 4.25449 11.4894C4.35157 11.3729 4.51597 11.3001 4.75676 11.3001C4.96651 11.3001 5.11753 11.3601 5.21531 11.4519C5.31254 11.5432 5.36774 11.6758 5.36774 11.8432C5.36774 12.0063 5.27477 12.133 5.09947 12.259C4.97056 12.3516 4.81239 12.4334 4.63814 12.5237C4.57045 12.5587 4.50033 12.595 4.42855 12.6337C3.92937 12.9026 3.38424 13.2721 3.38424 14.0621V14.3248V14.4248H3.48424H6.07456Z',
      fill: 'currentColor',
      stroke: 'currentColor',
      strokeWidth: '0.2',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.39941 19.9613H3.29941V20.0613C3.29941 20.4562 3.44651 20.7989 3.70434 21.0426C3.9618 21.2859 4.32366 21.4248 4.74439 21.4248C5.15422 21.4248 5.50746 21.2983 5.75959 21.074C6.01257 20.8489 6.15766 20.5305 6.15766 20.161C6.15766 19.7948 6.02237 19.5075 5.80021 19.3106C5.63041 19.1601 5.41442 19.0663 5.1791 19.0268L6.08837 18.098L6.11691 18.0688V18.028V17.6748V17.5748H6.01691H3.5081H3.4081V17.6748V18.2001V18.3001H3.5081H4.90616L4.08657 19.1921L4.02365 19.2606L4.08739 19.3283L4.37721 19.6363L4.42583 19.6879L4.49065 19.6591C4.55384 19.631 4.66918 19.6134 4.77156 19.6134C4.97827 19.6134 5.13808 19.6697 5.24438 19.7592C5.34896 19.8472 5.40971 19.9736 5.40971 20.1338C5.40971 20.3115 5.3455 20.4492 5.236 20.5438C5.12492 20.6399 4.95776 20.6995 4.73986 20.6995C4.53052 20.6995 4.36524 20.6332 4.25131 20.5245C4.13749 20.4159 4.067 20.2575 4.06091 20.0583L4.05794 19.9613H3.96095H3.39941Z',
      fill: 'currentColor',
      stroke: 'currentColor',
      strokeWidth: '0.2',
    }),
  );

export { IconOutlineNumberedList };
